import SignoutPage from "./components/SignoutPage/SignoutPage";

function App() {
  return <SignoutPage />;
}

export default App;
